import * as user from "./user";
import * as billing from "./billing";
import * as accounts from "./accounts";

const dependencies = {
  ...user,
  ...billing,
  ...accounts,
};

export default dependencies;

export type Dependencies = typeof dependencies;
